import { FabPositionedType } from "./FabPositioned.types";
import { FabPositionedStyled } from "./FabPositioned.styles";
import React, { useEffect, useState } from "react";

const handleScrollPosition = (
    setIsHidden: (v: boolean) => void,
    topOffsetToShow?: number,
) => {
    if (topOffsetToShow && window.scrollY <= topOffsetToShow) {
        setIsHidden(true);
    } else if (
        window.innerHeight + window.scrollY + 50 >=
            document.body.scrollHeight &&
        window.scrollY != 0
    ) {
        setIsHidden(true);
    } else {
        setIsHidden(false);
    }
};

export default function FabPositioned(props: FabPositionedType) {
    const {
        variant,
        position,
        children,
        hideOnEndOfView,
        topOffsetToShow,
        isInsideModal = false,
        ...restOfProps
    } = props;

    const [isHidden, setIsHidden] = useState(true);

    useEffect(() => {
        if (!hideOnEndOfView && !topOffsetToShow) {
            return;
        }
        handleScrollPosition(setIsHidden, topOffsetToShow);
        window.addEventListener(
            "scroll",
            () => handleScrollPosition(setIsHidden, topOffsetToShow),
            {
                passive: true,
            },
        );

        return () => {
            window.removeEventListener("scroll", () =>
                handleScrollPosition(setIsHidden, topOffsetToShow),
            );
        };
    }, [hideOnEndOfView, document.body.scrollHeight]);

    return (
        <FabPositionedStyled
            className={
                isHidden && hideOnEndOfView
                    ? "MuiFab-wrapper MuiFab-collapse"
                    : "MuiFab-wrapper"
            }
            position={position}
            isInsideModal={isInsideModal}
        >
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, { ...restOfProps, variant });
            })}
        </FabPositionedStyled>
    );
}
